import {useTranslation} from 'react-i18next';
import {useFormContext} from 'react-hook-form';
import {PATTERNS} from '@chekin/core';
import {Input} from '@chekinapp/ui';
import {FormFieldWrapper} from '../ui/FormFieldWrapper';

type EmailInputProps = {
  name: string;
  label: string;
};

const EmailInput = ({name, label}: EmailInputProps) => {
  const {t} = useTranslation();
  const {
    register,
    formState: {errors},
  } = useFormContext();

  return (
    <FormFieldWrapper className="!w-full">
      <Input
        label={label}
        {...register(name, {
          pattern: {
            value: PATTERNS.email,
            message: t('invalid_email'),
          },
        })}
        inputMode="email"
        autoCorrect="off"
        className="max-w-full"
        spellCheck={false}
        autoCapitalize="none"
        error={errors[name]?.message as string}
      />
    </FormFieldWrapper>
  );
};

export {EmailInput};
